
import $ from "jquery"
import Promise from "plugins/bluebird"
import IntlTelInput from "plugins/intl_tel_input"

import "bootstrap3-tooltip"
import "bootstrap3-popover"

import _extend from "lodash/assign"

import Modal from "app/modal/show-modal"
import ListingsContactNotifier from "../notifier/index"
import Formatter from "app/numbers/formatter"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"

import Track_ee from "../tracking/index"

import {
  refreshAndUpdateComponentPromise,
} from "app/authentication/remote_state"

import {
  create as create_user,
  ResultTypeEnums as CreateUserResultTypes,
} from "app/resources/users/create/index"

import {
  getContactInfoData,
  setContactInfoData,
} from "app/local_storages/contact_info_storage"

import {
  create as createListingContactRequests,
  ResultTypeEnums as createListingContactRequestResultTypes,
} from "app/resources/listing_contact_requests/create/index"

import {
  captureMessage,
  captureException,
} from "app/error_reporting"

import {
  isPresentString,
} from "app/utils/type_checking"

import {
  isSignedIn,
} from "app/authentication/state"

import {
  trackSignUp,
} from "app/authentication/tracking"


import I18n from "plugins/i18n-js"


const RejectionReasons = {
  ERROR_REPORTED:       "ERROR_REPORTED",
  FAILURE_CASE_HANDLED: "FAILURE_CASE_HANDLED",
}

interface Selector {
  scope: string | JQuery | Element
  main: string
  input_container: string
  contact_email_address_input: string
  contact_email_address_container: string
  contact_phone_number_input: string
  contact_phone_number_container: string
  contact_phone_number_dial_code: string
  reject_promotions_input: string
  tooltip: string,
}
interface InputSelector {
  scope?: string | JQuery | Element
  main?: string
  input_container?: string
  contact_email_address_input?: string
  contact_email_address_container?: string
  contact_phone_number_input?: string
  contact_phone_number_container?: string
  contact_phone_number_dial_code?: string
  reject_promotions_input?: string
  tooltip?: string,
}
interface InputOptions {
  popover_options?: Bootstrap3Popover.Options,
}
const default_selector = {
  scope:
    ".cell-listing-contact-request-box",
  main:
    "form",
  input_container:
    ".cell--listing--contact--request--box__input-container",
  contact_email_address_container:
    ".cell--listing--contact--request--box__input-container-contact-email-address",
  contact_email_address_input:
    ".cell--listing--contact--request--box__input-contact_email_address",
  contact_phone_number_container:
    ".cell--listing--contact--request--box__input-container-contact-phone-number",
  contact_phone_number_input:
    ".cell--listing--contact--request--box__input-contact_phone_number",
  contact_phone_number_dial_code:
    ".iti__selected-dial-code",
  reject_promotions_input:
    ".cell--listing--contact--request--box__input-reject_promotions",
  tooltip:
    ".cell--listing-contact-request-box--tooltip",
}

const DEFAULT_POPOVER_OPTIONS = {
  placement:  "auto",
}

const PAGE_EXPAND_CLASS = "page--filter--freeze"

const showErrorMessage = ($container: JQuery, error_message: string) => {
  const $error_div = $container.find(".cell--listing--contact--request--box--error")
  $error_div.text(`* ${error_message}`)
  $container.addClass("error")
}

const hideAllErrorMessages = ($scope: JQuery) => {
  const $input_divs = $scope.find(default_selector.input_container)
  $input_divs.removeClass("error")
}

const init = (selector?: InputSelector, options?: InputOptions) => {
  const merged_selector: Selector = _extend({}, default_selector, selector)
  const $scope = $(merged_selector.scope)
  const $form = $scope.find(merged_selector.main)

  const listing_id = $scope.data("listing-id")

  const $contact_email_address_input =
    $scope.find(merged_selector.contact_email_address_input)
  const $contact_email_address_container =
    $scope.find(merged_selector.contact_email_address_container)
  const $contact_phone_number_input =
    $scope.find(merged_selector.contact_phone_number_input)
  const $contact_phone_number_container =
    $scope.find(merged_selector.contact_phone_number_container)
  const $submit_button =
    $form.find(".cell-listing-contact-request-box__btn-send")
  const $submitted_button =
    $form.find(".cell-listing-contact-request-box__btn-sent")
  const $reject_promotions_input =
    $scope.find(merged_selector.reject_promotions_input)
  const $tooltip =
    $scope.find(merged_selector.tooltip)

  Promise.resolve(
    import(
      "plugins/js-routes"
    )
  )
  .then((Routes) => {
    const popover_options = Object.assign(
      {},
      DEFAULT_POPOVER_OPTIONS,
      options == null ? {} : options.popover_options,
      {
        container:  ".modal-scrollable",
        content:    I18n.t(
          "concepts.authentication.box.sentences.tooltip_html",
          {
            privacy_link: Routes.privacy_policy_page_path({locale: I18n.locale}),
          },
        ),
        html:       "true",
      },
    )
    $tooltip.popover(popover_options)
  })

  IntlTelInput.getIntlTelInput()
  .then((intlTelInput) => {
    WaitObjectByPathPromise("window._spacious_main_css_loaded")
    .then(() => {
      intlTelInput($contact_phone_number_input[0], {
        loadUtilsOnInit:  () => import("intl-tel-input/build/js/utils"),
        allowDropdown:    true,
        autoInsertDialCode: true,
        autoPlaceholder:  "polite",
        nationalMode:     false,
        separateDialCode: true,

        localizedCountries: (I18n.t(`plugins.intl_tel_input.iso2_code`) as any),
        preferredCountries: [
          "hk",
          "tw",
          "cn",
          "mo",
          "jp",
          "us",
          "gb",
        ],
        initialCountry: "auto",

        geoIpLookup: (callback: (c: string) => void) => {
          q_ajax_3({
            url:      "/my_country_code",
            method:   "GET",
            dataType: "json",
          })
          .then(({data}) => {
            const countryCode = (data?.country_code) ? data.country_code : ""
            callback(countryCode)
          })
          .catch(() => {
            // Do nothing
          })
          .done()
        },
      })
    })
    .done()

    $contact_phone_number_input.on("open:countrydropdown", () => {
      $("body").addClass(PAGE_EXPAND_CLASS)
    })

    $contact_phone_number_input.on("close:countrydropdown", () => {
      $("body").removeClass(PAGE_EXPAND_CLASS)
    })
  })

  $submit_button.on("click", (e) => {
    e.preventDefault()

    import(
      "libphonenumber-js"
    )
    .then(({isValidNumber: isValidPhoneNumber}) => {
      import(
        "email-validator"
      )
      .then(({validate: isValidEmailAddress}) => {
        hideAllErrorMessages($scope)

        const local_contact_info_data = getContactInfoData()

        const contact_email_address_input_val: null | string =
          $contact_email_address_input.val()
        const contact_phone_number_dial_code_text: string | null =
          $form.find(merged_selector.contact_phone_number_dial_code).text()
        const contact_phone_number_input_val: string | null =
          Formatter.phoneNumber(
            $contact_phone_number_input.val(),
            contact_phone_number_dial_code_text,
          )
        const reject_promotions_input_val: boolean =
          $reject_promotions_input.is(":checked")

        let error_reported = false
        if (! isPresentString(contact_email_address_input_val)) {
          const message = I18n.t("concepts.listings.contact.request.box.error_messages.missing_contact_email")
          showErrorMessage($contact_email_address_container, message)
          error_reported = true
        }
        if (! isValidEmailAddress(contact_email_address_input_val || "")) {
          const message = I18n.t("concepts.listings.contact.request.box.error_messages.invalid_contact_email")
          showErrorMessage($contact_email_address_container, message)
          error_reported = true
        }
        if (contact_phone_number_input_val == null || !isValidPhoneNumber(contact_phone_number_input_val)) {
          const message = I18n.t("concepts.listings.contact.request.box.error_messages.missing_phone_number")
          showErrorMessage($contact_phone_number_container, message)
          error_reported = true
        }

        if (error_reported) { return }

        $scope.addClass("cell-listing-contact-request-box-requesting")
        $submit_button.prop("disabled", true)
        $contact_phone_number_input.prop("disabled", true)
        $contact_email_address_input.prop("disabled", true)

        // Some hack to make flow happy zzz
        const valid_contact_email_address_input_val: string =
          contact_email_address_input_val || ""
        const valid_contact_phone_number_input_val: string =
          contact_phone_number_input_val || ""

        let auth_status_for_debug = "unknown"
        let create_listing_contact_requests_inputs_for_debug = {} as {[key: string]: any}
        let create_user_inputs = {}

        Promise.resolve()
        .then(() => {
          if (isSignedIn()) {
            auth_status_for_debug = "already_signed_in"
            return Promise.resolve()
          }

          const inputs = {
            authentication_handle:  local_contact_info_data.user_authentication_handle || valid_contact_email_address_input_val,
            email_address:          valid_contact_email_address_input_val,
            sign_in_on_success:     true,
          }
          create_user_inputs = inputs
          return create_user(inputs)
          .then(({result_type}) => {
            switch (result_type) {
              case CreateUserResultTypes.SUCCESS:
                auth_status_for_debug = "sign_up_success"
                trackSignUp()
                refreshAndUpdateComponentPromise().done()
                return
              case CreateUserResultTypes.CONFLICT:
                auth_status_for_debug = "sign_up_failed_due_to_conflict"
                return
              default:
                auth_status_for_debug =
                  `unexpected result_type from create_user: ${result_type}`
                captureMessage(
                  `unexpected/unhandled result_type: <${result_type}>`,
                  Object.assign({
                    "source_file_path":
                      "concepts/listings/contact/request/box/components/remote_submit_form/index",
                    "local_contact_info_data.user_authentication_handle":
                      local_contact_info_data.user_authentication_handle || "unknown",
                    "valid_contact_email_address_input_val":
                    valid_contact_email_address_input_val,
                  }, create_user_inputs),
                )
                throw RejectionReasons.ERROR_REPORTED
            }
          })
        })
        .then(() => {
          const create_listing_contact_requests_inputs = {
            user_authentication_handle: local_contact_info_data.user_authentication_handle || valid_contact_email_address_input_val,

            listing_id: listing_id,

            listing_contact_request_attributes: {
              requester_email_address:
              valid_contact_email_address_input_val,

              requester_phone_number:
              valid_contact_phone_number_input_val,
            },

            reject_promotions: reject_promotions_input_val,
          }
          // Store for later error reporting if needed
          create_listing_contact_requests_inputs_for_debug = create_listing_contact_requests_inputs

          return createListingContactRequests(create_listing_contact_requests_inputs)
        })
        .then(({result_type, data}) => {
          if (result_type === createListingContactRequestResultTypes.UNAUTHENTICATED) {
            ListingsContactNotifier.showAlert(I18n.t("devise.failure.unauthenticated"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          // Pointless to show contact modal since unauthorized
          if (result_type === createListingContactRequestResultTypes.UNAUTHORIZED) {
            ListingsContactNotifier.showAlert(I18n.t("app_resources.listing_contact_requests_create.errors.unauthorized"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type === createListingContactRequestResultTypes.LISTING_EXPIRED) {
            ListingsContactNotifier.showAlert(I18n.t("app_resources.listing_contact_requests_create.errors.listing_expired"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          // Since enquiry already sent
          // We prevent further enquiries to be created
          // And no modal shown
          if (result_type === createListingContactRequestResultTypes.CONFLICTING_RESOURCE_ALREADY_EXISTS) {
            ListingsContactNotifier.showAlert(I18n.t("app_resources.listing_contact_requests_create.errors.conflicting_resource_already_exists"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type === createListingContactRequestResultTypes.LISTING_CONTACT_EMAIL_OR_PHONE_ABSENT) {
            ListingsContactNotifier.showAlert(I18n.t("app_resources.listing_contact_requests_create.errors.contact_email_or_phone_absent"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type === createListingContactRequestResultTypes.INVALID_CONTACT_PHONE_NUMBER) {
            ListingsContactNotifier.showAlert(I18n.t("app_resources.listing_contact_requests_create.errors.invalid_contact_phone_number"))
            throw RejectionReasons.FAILURE_CASE_HANDLED
          }

          if (result_type !== createListingContactRequestResultTypes.SUCCESS || data == null) {
            captureMessage(
              `unexpected result_type from createListingContactRequests: ${result_type}`,
              {
                source_file_path:
                  "concepts/listings/contact/request/box/components/remote_submit_form/index",
                valid_contact_email_address_input_val:
                  valid_contact_email_address_input_val,
                valid_contact_phone_number_input_val:
                  valid_contact_phone_number_input_val,
                user_status_for_debug:
                  auth_status_for_debug,
                create_listing_contact_requests_inputs_for_debug:
                  JSON.stringify(create_listing_contact_requests_inputs_for_debug),
              }
            )
            throw RejectionReasons.ERROR_REPORTED
          }

          return data
        })
        .then((data) => {
          // Update cached contact info
          if (isPresentString(contact_email_address_input_val)) {
            setContactInfoData({
              contact_email_address: contact_email_address_input_val,
            })
          }
          if (contact_phone_number_input_val != null &&
            isPresentString(contact_phone_number_input_val) &&
            isValidPhoneNumber(contact_phone_number_input_val)) {
            setContactInfoData({
              contact_phone_number: contact_phone_number_input_val,
            })
          }

          Track_ee.emit(
            "successful_submit",
            listing_id,
            $submit_button.data("is-rental"),
            $submit_button.data("is-commercial"),
          )

          Modal.hideTopModal()
          ListingsContactNotifier.showAlert(I18n.t("app_resources.listing_contact_requests_create.success"))
          $submitted_button.addClass("done")
        })
        .catch((whatever) => {
          $scope.removeClass("cell-listing-contact-request-box-requesting")
          $submit_button.prop("disabled", false)
          $contact_phone_number_input.prop("disabled", false)
          $contact_email_address_input.prop("disabled", false)

          if (whatever === RejectionReasons.FAILURE_CASE_HANDLED) { return }

          ListingsContactNotifier.showAlert(I18n.t("js.app.notifier.defaults.form_submit_failed"))

          if (whatever === RejectionReasons.ERROR_REPORTED) { return }

          if (whatever instanceof Error) {
            captureException(
              whatever,
              {
                source_file_path:
                  "concepts/listings/contact/request/box/components/remote_submit_form/index",
              }
            )
            return
          }

          captureMessage(
            `rejected w/ something unexpected: ${whatever}`,
            {
              source_file_path:
                "concepts/listings/contact/request/box/components/remote_submit_form/index",
            }
          )
        })
        .done()
      })
    })
  })
}

export default {init}
